module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_1.1ea902c0.png";